import { S } from '@/shared/constants/styles';
import { CategoryBadge } from '@/features/categories';

export default function MobileTransactionCard({ transaction: t, onEdit, onDelete, onSplit, onDeleteAllSplits, deleteTxId, setDeleteTxId, incomeList, currency, theme, anomalyMap = new Map() }) {
  const fmtAUD = (v) => (Number(v) || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const isIncome = incomeList.includes(t.category);
  const anomaly = anomalyMap.get(t.id);
  const th = theme;

  return (
    <div style={{ padding: '14px 0', borderBottom: '1px solid ' + th.cardBorder }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 14, color: th.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{String(t.description || "No description")}</span>
            {t.splitGroupId && (
              <span style={{
                fontSize: 10, fontWeight: 700, padding: '1px 5px', flexShrink: 0,
                background: 'rgba(168,85,247,0.15)', color: '#a855f7',
                border: '1px solid rgba(168,85,247,0.3)', borderRadius: 4,
              }}>split</span>
            )}
          </div>
          <div style={{ fontSize: 12, color: th.textMuted, marginTop: 2 }}>{String(t.date || "")}</div>
        </div>
        <div style={{ fontWeight: 700, fontSize: 15, color: isIncome ? "#16a34a" : th.text, marginLeft: 12, whiteSpace: 'nowrap' }}>
          {(isIncome ? "+" : "-") + currency + fmtAUD(t.amount)}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <CategoryBadge category={t.category} theme={theme} />
        {t.who && <span style={{ fontSize: 11, color: th.textMuted }}>{String(t.who)}</span>}
        {t.paymentMethod && <span style={{ fontSize: 11, color: th.textMuted }}>{String(t.paymentMethod)}</span>}
        {(t.tags || []).map(tag => (
          <span key={tag} style={{
            background: 'rgba(99,102,241,0.15)',
            color: '#6366f1',
            border: '1px solid rgba(99,102,241,0.3)',
            borderRadius: 5, padding: '1px 6px', fontSize: 10, fontWeight: 600,
          }}>{tag}</span>
        ))}
        {anomaly && (
          <span style={{
            fontSize: 10, fontWeight: 700, padding: '1px 5px',
            background: anomaly.type === 'high-amount' ? 'rgba(239,68,68,0.15)' : 'rgba(245,158,11,0.15)',
            color: anomaly.type === 'high-amount' ? '#ef4444' : '#d97706',
            border: '1px solid ' + (anomaly.type === 'high-amount' ? 'rgba(239,68,68,0.3)' : 'rgba(245,158,11,0.3)'),
            borderRadius: 4,
          }}>
            {anomaly.type === 'high-amount' ? 'unusual' : 'new'}
          </span>
        )}
      </div>
      <div style={{ display: 'flex', gap: 12, marginTop: 8, flexWrap: 'wrap' }}>
        {!t.splitGroupId && onSplit && (
          <button onClick={() => onSplit(t)} style={{ ...S.link('#a855f7'), minHeight: 44, display: 'inline-flex', alignItems: 'center', fontSize: 13 }}>Split</button>
        )}
        <button onClick={() => onEdit(t)} style={{ ...S.link("#3b82f6"), minHeight: 44, display: 'inline-flex', alignItems: 'center', fontSize: 13 }}>Edit</button>
        {deleteTxId === t.id ? (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, minHeight: 44, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 12, color: theme.textMuted }}>Delete?</span>
            <button onClick={() => onDelete(t.id)} style={{ ...S.link("#ef4444"), fontWeight: 700, fontSize: 13 }}>Yes</button>
            {t.splitGroupId && onDeleteAllSplits && (
              <button onClick={() => onDeleteAllSplits(t.splitGroupId)} style={{ ...S.link("#ef4444"), fontWeight: 700, fontSize: 13 }}>All splits</button>
            )}
            <button onClick={() => setDeleteTxId(null)} style={{ ...S.link(theme.textMuted), fontSize: 13 }}>No</button>
          </span>
        ) : (
          <button onClick={() => setDeleteTxId(t.id)} style={{ ...S.link("#ef4444"), minHeight: 44, display: 'inline-flex', alignItems: 'center', fontSize: 13 }}>Delete</button>
        )}
      </div>
    </div>
  );
}
